import { createBrowserRouter } from 'react-router';
import { RootLayout } from '@/components/layout/RootLayout';
import { RouteError } from '@/components/RouteError';
import { authRoutes } from '@/features/auth/routes';
import { profileRoutes } from '@/features/profile/routes';
import { siteRoutes } from '@/features/sites/routes';
import { promotionRoutes } from '@/features/promotions/routes';
import { marketRoutes } from '@/features/market/routes';
import { raceRoutes } from '@/features/races/routes';
import { storyRoutes } from '@/features/stories/routes';
import { milestoneRoutes } from '@/features/milestones/routes';
import { ticketRoutes } from '@/features/tickets/routes';
import { HomePage } from '@/pages/HomePage';
import { MoonPage } from '@/pages/MoonPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

/**
 * Route table.
 *
 * A feature owns its routes and exports them from
 * `src/features/<feature>/routes.tsx`; this file is a one-line-per-feature index
 * rather than a place every change has to touch.
 */
export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <HomePage /> },

      // Tek partnere ait bir kampanya sayfasi: metni kendi dosyasinda duruyor,
      // catalog'daki sitelerden bagimsiz. Bir ozelligin parcasi degil, o yuzden
      // rota da burada.
      { path: 'moon', element: <MoonPage /> },

      ...authRoutes,
      ...siteRoutes,
      ...storyRoutes,
      ...promotionRoutes,
      ...raceRoutes,
      ...ticketRoutes,
      ...marketRoutes,

      ...milestoneRoutes,
      ...profileRoutes,

      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
